/* eslint-disable import/no-anonymous-default-export */

import apiCall from "./apiCall";

export default {
  async listPayees(data) {
    let response = await apiCall("payee/list", data);
    return response;
  },

  async addVendor(vendorName, description, address, phoneNumber, emailAddress) {
    let data = {
      payee_name: vendorName,
      description: description,
      address: address,
      phone_number: phoneNumber,
      email: emailAddress,
    };
    let response = await apiCall("payee/create", data);
    return response;
  },

  async importPayees(importFile) {
    let data = { vendor_file: importFile };
    let response = await apiCall("payee/import", data);
    return response;
  },

  async fetchVendorCount() {
    let response = await apiCall("transaction/payee/count", []);
    return response;
  },

  async fetchVendorSearch(hint) {
    const data = {
      hint: hint
    }
    let response = await apiCall("transaction/payee/search_payee", data);
    return response;
  },

  async fetchPayeeTransCount(payeeId) {
    const data = {
      payee_id: payeeId
    }
    let response = await apiCall("transaction/ledger/count_payee_transactions", data);
    return response;
  },

  async fetchPayeeTransactions(data) {
    let response = await apiCall("transaction/ledger/list_payee_transactions", data);
    return response;
  },

  async fetchPayeeTransAccounts(payeeId) {
    const data = {
      payee_id: payeeId
    }
    let response = await apiCall("transaction/ledger/get_payee_trans_accounts", data);
    return response;
  },
  
  async fetchPayeeStatement(data) {
    let response = await apiCall("report/accountstatement/payee_statement", data);
    return response;
  },
  
};
